export enum Claim {
    UserId = 'api.kampcoating.userId',
    UserName = 'api.kampcoating.userName',
    Roles = 'api.kampcoating.role',
    Rights = 'api.kampcoating.right',
    ActiveLanguage = 'api.kampcoating.activeLanguage',
    CurrentCompanyId = 'api.kampcoating.currentCompanyId',
    UserCompanyRight = 'api.kampcoating.userCompanyRight'
}
